import { h } from "preact";
import MiniCartItem from "./mini-cart-item";
import MiniCartBundleProgress from "./mini-cart-bundle-progress";

export default function MiniCartItemGroup({
  items,
  currency,
  swatchLimitEach,
  showStockAttribute,
  shouldSubdue,
}) {
  return (
    <div className="mini-cart__item-group">
      <MiniCartBundleProgress items={items} currency={currency} />
      {items.map((item) => (
        <MiniCartItem
          key={item.id}
          item={item}
          currency={currency}
          swatchLimitEach={swatchLimitEach}
          showStockAttribute={showStockAttribute}
          subdue={shouldSubdue(item)}
        />
      ))}
    </div>
  );
}
